import React, { useState } from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Stack from 'react-bootstrap/Stack';
import MonitoringListSelect from '../Components/FormComponents/MonitoringListSelect';
import ExportFieldsModal, {
  CLIENT_EXPORT_FIELDS,
  ExportField
} from '../Components/FormComponents/ExportFieldsModal';
import { downloadAsCsv } from '../Functions';
import { Download } from 'react-bootstrap-icons';
import { useMonitoringListQuery } from '../queries/monitoring.query';
import { customFetch } from '../helpers/customFetch';

const DownloadClientPlates = () => {
  const { data: monitoringLists } = useMonitoringListQuery({ enabled: true });
  const [monitoringListId, setMonitoringListId] = useState('');
  const [onlyMonitorePlates, setOnlyMonitorePlates] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const { unassignedMonitoringItem } = monitoringLists || {};

  const handleExport = (selectedFields: ExportField[]) => {
    setIsLoading(true);
    const params = new URLSearchParams();
    if (monitoringListId) params.append('monitoringListId', monitoringListId);
    if (!!monitoringListId && monitoringListId !== unassignedMonitoringItem?.id) {
      params.append('onlyMonitoredPlates', onlyMonitorePlates.toString());
    }
    if (selectedFields.length > 0) {
      params.append('fields', selectedFields.map((f) => f.value).join(','));
    }
    const requestConfig: RequestInit = {
      headers: {
        'Content-Type': 'text/csv;charset=UTF-8'
      }
    };
    const endpoint = '/Client/DownloadClientsWithPlates?' + params.toString();
    customFetch<any>({
      endpoint,
      config: requestConfig,
      skipParseBody: true,
      callback: async (res) => {
        downloadAsCsv(await res.text(), `Client Plates ${new Date().toLocaleString()}`);
        setIsLoading(false);
        setShowModal(false);
      }
    });
  };

  return (
    <>
      <Form style={{ marginBottom: 15 }}>
        <Stack direction="vertical" gap={2}>
          <Form.Text style={{ whiteSpace: 'pre-wrap' }}>
            Download a spreadsheet of all clients with their plates
          </Form.Text>
          <Stack direction="horizontal" gap={3}>
            {showFilter &&
              monitoringListId &&
              monitoringListId !== unassignedMonitoringItem?.id && (
                <Form.Check
                  checked={onlyMonitorePlates}
                  label="Only plates that are being monitored"
                  onChange={(e) => setOnlyMonitorePlates(e.currentTarget.checked)}
                />
              )}
            {showFilter && (
              <MonitoringListSelect
                value={monitoringListId}
                addNew={false}
                showAllOption={true}
                handleDataChange={(_, value) => setMonitoringListId(value)}
              />
            )}
            <Button
              className="ms-auto"
              style={{ whiteSpace: 'nowrap' }}
              variant={showFilter ? 'secondary' : 'primary'}
              onClick={() => {
                if (showFilter) {
                  setMonitoringListId('');
                }
                setShowFilter(!showFilter);
              }}>
              {showFilter ? 'Clear Filter' : 'Add Filter'}
            </Button>
            <Button variant="primary" onClick={() => setShowModal(true)}>
              <Download />
            </Button>
          </Stack>
        </Stack>
      </Form>

      <ExportFieldsModal
        show={showModal}
        onHide={() => setShowModal(false)}
        onExport={handleExport}
        availableFields={CLIENT_EXPORT_FIELDS}
        title="Export Client Plates"
        isLoading={isLoading}
      />
    </>
  );
};

export default DownloadClientPlates;
